import React from "react"

type Props = {
  title: string
  children: any
  className?: string
}

const ContentVideoSection: React.FC<Props> = ({
  title,
  children,
  className,
}) => {
  return (
    <section
      className={`section-py ${className}`}
      data-aos="fade-up"
      data-aos-duration="700"
      data-aos-delay="300"
    >
      <div className="container xl:container mx-auto">
      
        <div className="row flex justify-center">
          <div className="lg:w-8/12 px-1">
            <div className="text-center">
              <h2 className="mb-5 fw-700 fs-xl">{title}</h2>
              {children}
            </div>
          </div>
          
        </div>
      </div>
    </section>
  )
}

export default ContentVideoSection
